import Newsletter from "../home/newsletter";
import style from "./pricing.module.css";
import { Helmet } from "react-helmet-async";

export default function Pricing() {
        return (
    <>
     <Helmet>
        <title>Pricing & Transaction Fees for Fundraising Campaigns</title>
         <meta
          name="description"
          content="Learn about FundLife’s campaign fees—standard processing at 2.7% + $0.30 per donation, with specific exceptions for non-USD campaigns and international donations. Explore clear, transparent pricing for churches, families, and community fundraising."
        />
         <meta
          property="og:description"
          content="Learn about FundLife’s campaign fees—standard processing at 2.7% + $0.30 per donation, with specific exceptions for non-USD campaigns and international donations. Explore clear, transparent pricing for churches, families, and community fundraising. "
        />
       
        <meta
          name="keywords"
          content=" FundLife pricing, campaign fees, crowdfunding transaction fees, donation processing rates, non‑USD campaign fees, international campaign pricing, church fundraising costs"
        /> 
      </Helmet>
        <div>
            < div className={` d-flex justify-content-center align-items-center ${style.main}`}>
                <div className=" innercontainer  px-3 px-md-0">
                    <div className="fs-1 fw-bold text-center text-white pt-5  ">
                        Pricing and Fees
                    </div>
                </div>
            </div>
            <div className=" innercontainer  px-3 px-md-0">
                <div className={`d-flex justify-content-between flex-column flex-md-row ${style.mtneg}   mx-auto`}>
                    <div className={`d-flex justify-content-center align-items-center ${style.box} `}> 
                        <div className={`text-center d-flex flex-column justify-content-around ${style.boxContainer}`}>
                            <h3 className="fs-5 fw-semibold lh-base">FundLife Platform Fees</h3>
                            <h1 className={`lh-lg fw-semibold ${style.boxText2}`}>0%</h1>
                            <h5 className={`lg-base fs-5 fw-normal`}>+ $0 Per Donation</h5>
                        </div>
                    </div>
                    <div className={`d-flex align-items-center justify-content-center`}>
                        <h4 className={style.black}>+</h4>
                    </div>

                    <div className={`d-flex justify-content-center align-items-center ${style.box} `}>
                        <div className={`text-center d-flex flex-column  align-items-center justify-content-around ${style.boxContainer}`}>
                            <h3 className="fs-5 fw-semibold lh-base">Third party Processing fees</h3>
                            <h1 className={`lh-lg fw-semibold ${style.boxText2}`}>2.7%</h1>
                            <h5 className={`lg-base fs-5 fw-normal`}>+ $0.30 Per Donation*</h5>
                        </div>
                    </div>
                    <div className={`d-flex align-items-center justify-content-center`}>
                        <h4 className={style.black}>=</h4></div>
                    <div className={`d-flex justify-content-center align-items-center  ${style.boxLast}`}>
                        <div className={`text-center d-flex flex-column justify-content-around ${style.boxContainer}`}>
                            <h3 className="fs-5 fw-semibold lh-base text-white">Total</h3>
                            <h1 className={`lh-lg fw-semibold text-white ${style.boxText2}`}>2.7%</h1>
                            <h5 className={`lg-base fs-5 fw-normal text-white`}>+ $0.30 Per Donation</h5>
                        </div>
                    </div>
                </div>
                <div className={`w-100 w-lg-75 mx-auto mt-5 px-5 ${style.paragraph} `}>
                    <h6 className={`fs-5 lh-base`}>*Please note the following exceptions to our standard pricing and fees of 2.7% + $0.30 per donation:</h6>
                    <ul >
                        <li className={`fs-5 lh-base`}>Non-USD Campaigns: For campaigns that are not in USD, a fee of 3.5% + $0.30 per donation applies.</li>
                        <li className={`fs-5 lh-base`}>Non-USD Donations to USD Campaigns: Donations made in non-USD currencies to USD campaigns will incur an additional 1% fee on top of the standard 2.7% + $0.30 fee.</li>
                        <li className={`fs-5 lh-base`}>Currency Exchange Fees: Non-USD campaigns may incur additional currency exchange fees as determined by our payment processor.</li>
                    </ul>
                </div>
            </div>
            <Newsletter />
        </div>
        

    </>
    )    
}